<script setup lang="ts">
interface Props {
  productCode: string
  argentoInsuranceCompanyId?: number
}

const props = defineProps<Props>()

const { RemoteConfigurationStore, LocalConfigurationStore } = stores()

const productData = computed(() =>
  LocalConfigurationStore.value?.productsInfo?.find((p) => p.code === props.productCode)
)

const associatedCompanies = computed(() => LocalConfigurationStore.value?.associatedCompanies ?? [])

const selectedCompany = computed(() =>
  associatedCompanies.value.find((c) => c.argentoInsuranceId === props.argentoInsuranceCompanyId)
)

const heading = computed(() => {
  if (!props.argentoInsuranceCompanyId) {
    switch (RemoteConfigurationStore.value?.initBy) {
      case 'BySubRamo':
        return { main: `Comparador de ${productData.value?.name ?? productData.value?.alias}` }
      default:
        return { main: `Seguro de ${productData.value?.name ?? productData.value?.alias}` }
    }
  } else {
    return {
      main: `Seguro de ${productData.value?.alias ?? productData.value?.name}`,
      sub: selectedCompany.value?.name,
    }
  }
})
</script>
<template>
  <div
    v-if="heading"
    class="flex gap-2 md:gap-4 items-center leading-none"
  >
    <ImageComponent
      :src="`/siteAssets/img|product-icons/${productData?.iconFile}`"
      :alt="productData?.name"
      class="size-10 rounded-md lg:size-14"
    />
    <div class="self-stretch lg:hidden inline">
      <PvDivider layout="vertical" />
    </div>
    <div class="flex font-bold uppercase flex-col lg:gap-1 text-2xl sm:text-4xl">
      <span class="font-bold title-text items-center leading-none">
        {{ heading.main }}
      </span>
      <span class="text-xl title-text leading-none">
        {{ heading.sub }}
      </span>
    </div>
  </div>
</template>
